import type { PropsWithChildren } from 'react';

import { HStack, Heading } from '@frontend/legacy-components';

export type PageHeaderProps = PropsWithChildren<unknown>;

export const PageHeader = ({ children }: PageHeaderProps) => {
  return (
    <HStack spacing={2}>
      <Heading>Orders</Heading>
      {children}
    </HStack>
  );
};
